import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['project-report'],
        systemName: '在建工程关键要素报表',
    };
};
export const JgToPathNameMap = {
    project2100: ({ businessKey }) => commonFunc(`/management/detail?id=${businessKey}`),
    project2200: ({ businessKey }) => commonFunc(`/work/detail?id=${businessKey}`),
    project2300: ({ businessKey }) => commonFunc(`/material/detail?id=${businessKey}`),
    project2400: ({ businessKey }) => commonFunc(`/construction/detail?id=${businessKey}`),
    project2500: ({ businessKey }) => commonFunc(`/manager-info/detail?id=${businessKey}`),
    project2600: ({ businessKey }) => commonFunc(`/materials-device/detail?id=${businessKey}`),
    project2700: ({ businessKey }) => commonFunc(`/consub/detail?id=${businessKey}`),
    project2800: ({ businessKey }) => commonFunc(`/project-info/addition/detail?id=${businessKey}`),
    project2900: ({ businessKey }) => commonFunc(`/project-info/adjustment/detail?id=${businessKey}`),
};
